import React from "react";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import EYouthProjects from "../../components/EYouthProjects/EYouthProjects";
import JoinUs from "../../components/JoinUs/JoinUs";
import MostLearning from "../../components/MostLearning/MostLearning";
import OurPrograms from "../../components/OurPrograms/OurPrograms";
import OurPartners from "../../components/Ourpartners/Ourpartners";
import TopRanking from "../../components/TopRanking/TopRanking";
import Dashboard from "../../components/dashboard/dashboard";
import Introduction from "../../components/introduction/introduction";
import Trainer from "../../components/trainer/trainer";
import WhyEYouth from "../../components/whyEYouth/whyEYouth";
import { ECOMMERCE_URL } from "../../config/constants";
// import PopupStepper from "../UserReview/PopupStepper"; // Import PopupStepper
// import InitialPopup from "../InitialPopup/InitialPopup"; // Import InitialPopup
import "./home.css";
// import InitialPopup from '../UserReview/ InitialPopup';

const Home = () => {
  const [searchParams] = useSearchParams();
  // const [isInitialPopupOpen, setInitialPopupOpen] = useState(false);
  // const [isSurveyPopupOpen, setSurveyPopupOpen] = useState(false);
  // const [session, setSession]   = useState(JSON.parse(localStorage.getItem("user_stu") || "{}"));

  let token = searchParams.get("token");
  if (token) {
    window.location.href = ECOMMERCE_URL;
  }

  // useEffect(() => {
  //   if (session.username) {
  //     const requestOptions = {
  //       method: "GET",
  //       redirect: "follow"
  //     };

  //     fetch(`https://python.eyouthlearning.com/survey/checksurvey/?username=${session.username}`, requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         if (result.need_survey === "true") {
  //           setInitialPopupOpen(true);
  //         }
  //       })
  //       .catch((error) => console.error("Error fetching survey status:", error));
  //   }
  // }, [session.username]);

  // const handleProceed = () => {
  //   setInitialPopupOpen(false);
  //   setSurveyPopupOpen(true);
  // };

  // const handleCloseInitialPopup = () => {
  //   setInitialPopupOpen(false);
  // };

  return (
    <>
      <div className="">
        <Helmet>
          <title>Home-EYouth</title>
          <meta name="description" content="Home page of EYouth"></meta>
        </Helmet>
        <Introduction />
        <MostLearning />
        <TopRanking />
        <OurPrograms />
        <Dashboard />
        <WhyEYouth />
        <Trainer />
        <JoinUs />
        <EYouthProjects />
        <OurPartners />
        {/* {isInitialPopupOpen && (
          <InitialPopup onProceed={handleProceed} onClose={handleCloseInitialPopup} />
        )} */}
        {/* {isSurveyPopupOpen && (
          <PopupStepper open={isSurveyPopupOpen} onClose={() => setSurveyPopupOpen(false)} />
        )} */}
      </div>
    </>
  );
};

export default withTranslation()(Home);
